export default __webpack_public_path__ + "9d53b9640bc5be9949de1075a3ddef9f.png";